import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectSidebarCollapsed } from '@/store/slices/ui.selectors';
import { toggleSidebarCollapsed } from '@/store/slices/ui.slice';

export function useSidebar() {
  const dispatch = useAppDispatch();
  const collapsed = useAppSelector(selectSidebarCollapsed);

  const toggleCollapsed = useCallback(() => dispatch(toggleSidebarCollapsed()), [dispatch]);

  return { collapsed, toggleCollapsed };
}
